import React from "react";
import BreadCrumbs from "../common/BreadCrumbs";
import { INDUSTRIES } from "../constants/IndustryConstant";
import ArrowIcon from "../common/svg/ArrowIcon";
import { Link } from "react-router-dom";

const Industry = () => {
  return (
    <>
      <BreadCrumbs title="Industries" description="Solutions for all industries" />

      <div className="home5-case-study sec-mar">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {INDUSTRIES.map(
                ({ id, tag, title, description, cardImage, delay }) => (
                  <div
                    className="single-case-study wow animate fadeInUp"
                    data-wow-delay={delay}
                    data-wow-duration="1500ms">
                    <div className="row g-4">
                      <div className="col-lg-5 d-flex align-items-center">
                        <div className="case-study-content">
                          <span> {tag} </span>
                          <h3>
                            <Link to={`/industries/${id}`}> {title} </Link>
                          </h3>
                        </div>
                      </div>
                      <div className="col-lg-7">
                        <div className="case-study-img-and-btn">
                          <div className="case-img magnetic-item">
                            <img
                              className="img-fluid"
                              src={cardImage}
                              alt={title}
                            />
                          </div>
                          <div className="learn-more-btn">
                            <Link
                              className="primary-btn8"
                              to={`/industries/${id}`}>
                              <ArrowIcon />
                              LEARN MORE
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Industry;
